import {
  IPosOrder,
  IPostOrderPOS,
  IPutOrderPOS,
} from '@modules/point-of-sale/interface/orders/pos-orders.interface';
import { hashSignature } from './security';

export const buildVaryingPrice = (
  order: IPosOrder,
): number[] | number | null => {
  if (!order.isVaryingPrice) return null;

  const quantity = Number(order.quantity) || 0;
  const unitAmount = quantity
    ? Number(order.grossAmount) / quantity
    : Number(order.unitPrice) || 0;

  return unitAmount;
};

export const buildPosOrderPayload = ({
  orders,
  propertyID,
  stationID,
  includeExistingOrderID = false,
}: {
  orders: IPosOrder[];
  propertyID: string;
  stationID: string;
  includeExistingOrderID?: boolean;
}): { posOrder: IPostOrderPOS }[] =>
  orders.map((order) => {
    const orderID =
      includeExistingOrderID && order.orderID ? order.orderID : null;
    const varyingPrice = buildVaryingPrice(order);

    const signature = hashSignature(
      [
        propertyID,
        orderID ?? 'null',
        stationID,
        order.menuID,
        order.quantity,
        order.lineRemarks,
        'null',
        'null',
        'null',
        varyingPrice ?? 'null',
      ].join(''),
    );

    return {
      posOrder: {
        orderID,
        stationID,
        menuID: order.menuID,
        orderQuantity: String(order.quantity),
        lineRemarks: order.lineRemarks,
        modifyServiceChargePercentage: null,
        modifyLocalTaxPercentage: null,
        modifyVatType: null,
        varyingPrice,
        signature,
      },
    };
  });

export const buildPutOrderPayload = ({
  order,
  propertyID,
  stationID,
  quantity = order.quantity,
  lineRemarks = order.lineRemarks,
}: {
  order: IPosOrder;
  propertyID: string;
  stationID: string;
  quantity?: number;
  lineRemarks?: string;
}): { posOrder: IPutOrderPOS } => {
  const nextOrder = {
    ...order,
    quantity,
    lineRemarks,
    grossAmount: order.unitPrice * quantity,
  };
  const varyingPrice = buildVaryingPrice(nextOrder);

  const signature = hashSignature(
    [
      propertyID,
      stationID,
      order.menuID,
      quantity,
      lineRemarks,
      'null',
      'null',
      'null',
      varyingPrice ?? 'null',
    ].join(''),
  );

  return {
    posOrder: {
      stationID,
      menuID: order.menuID,
      orderQuantity: String(quantity),
      lineRemarks,
      modifyServiceChargePercentage: null,
      modifyLocalTaxPercentage: null,
      modifyVatType: null,
      varyingPrice,
      signature,
    },
  };
};
